import { Button, Drawer, Group, Paper, Stack, Text, Title } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconPencil, IconPlus, IconX } from "@tabler/icons-react";
import { formatAddress } from "../../functions/programregistration.functions";
import { ParentGuardian } from "../../models/programregistration.models";
import { useProgramRegistrationState } from "../../state/programregistration.state";
import ParentGuardianEditor from "./ParentGuardianEditor";

interface Props {
	
}

const ParentGuardianListEditor = ({ }: Props) => {
	const [opened, { open, close }] = useDisclosure(false);
	const { programRegistration, getParentGuardians, isCancelled, isDeleted, status } = useProgramRegistrationState();
	const useNewDesign = import.meta.env.VITE_NEW_DESIGN === "true";

	return <>
		<Button onClick={open} disabled={!status.canEdit || isCancelled || isDeleted} variant={useNewDesign ? "subtle" : "light"} size="xs" style={{ flex: 'none' }} leftSection={getParentGuardians().length === 0 ? <IconPlus /> : <IconPencil />}>
			{getParentGuardians().length === 0 ? "Add" : "Edit"}
		</Button>

		<Drawer opened={opened} onClose={close} title={<div><Title order={3}>Parents/Guardians</Title></div>} position="right" size="md" withCloseButton>
			{getParentGuardians().map((parentGuardian, index) => {
				return <ParentGuardianListEditorItem key={index} parentGuardian={parentGuardian} />
			})}

			{getParentGuardians().length === 0 && <>
				<Text c="dimmed">There are no parents/guardians</Text>
			</>}

			<ParentGuardianEditor registrationId={programRegistration.Id} parentGuardianId="" add />
		</Drawer>
	</>
}

export default ParentGuardianListEditor

interface ParentGuardianListEditorItemProps {
	parentGuardian: ParentGuardian;
}

const ParentGuardianListEditorItem = ({ parentGuardian }: ParentGuardianListEditorItemProps) => {
	const { programRegistration, deleteParentGuardian } = useProgramRegistrationState();
	const handleDeleteParentGuardian = (parentGuardianId: string) => {
		deleteParentGuardian(parentGuardianId); 
	}

	const canDelete = true;//programRegistration.Data.ParentGuardians.length > 1;

	return <Paper p="sm" mb="md" withBorder shadow="sm">
		<Group justify="space-between" align="flex-start" wrap="nowrap">
			<Stack gap={0}>
				<Text size="lg" fw="bold" span>{parentGuardian?.Salutation} {parentGuardian.FirstName} {parentGuardian.LastName} </Text>
					{/* <Text size="sm" component="span" color="dimmed">({getGender(parentGuardian)}, Adult)</Text> */}
				<Text size="xs" c="dimmed">{formatAddress(parentGuardian.Address, false)}</Text>
			</Stack>
			<Stack gap="xs">
				<ParentGuardianEditor registrationId={programRegistration.Id} parentGuardianId={parentGuardian.Id} />
				<Button onClick={() => handleDeleteParentGuardian(parentGuardian.Id)} disabled={!canDelete} variant="light" size="xs" leftSection={<IconX />}>Delete</Button>
			</Stack>
		</Group>
			
	</Paper>
}